import styled from 'styled-components';

export const ButtonDiv = styled.div`
  font-family: Sora;
  width: 6.86rem;
  height: 2.68rem;
  margin-right: 2rem;

  Button {
    background: #ffffff;
    border: 1.97029px solid #d4d6da;
    box-sizing: border-box;
    border-radius: 8.44412px;
    font-family: Sora;
    color: #7e858f;
    margin-left: 2rem;
  }
  svg {
    fill: #7e858f;
    margin-right: 0.4rem;
  }
`;

export const ActivedButtonContainer = styled.div`
  position: relative;
  width: 13.5rem;
  margin-left: 2rem;
  z-index: 100;

  button {
    font-family: Sora;
  }
  button:nth-child(1) {
    color: #42464c;

    path {
      stroke: #42464c;
    }

    svg {
      margin-right: 0.4rem;
    }
  }
`;

export const ActiveMenu = styled.div`
  position: absolute;
  width: 17.641875rem;
  top: 3.75rem;
  background: #ffffff;
  border-radius: 0.5rem;
  display: flex;
  flex-direction: column;
  box-shadow: 0px 5.64541px 11.2908px rgba(20, 20, 20, 0.3);
`;

export const MenuNone = styled.div`
  padding: 1.32rem 0rem 0.8rem 1.32rem;

  display: flex;
  align-items: center;
  justify-content: space-between;

  border-bottom: 2px solid #eff1f5;

  cursor: pointer;

  :hover {
    border-radius: 0.5rem;
    background: #eff1f5;
  }
`;

export const MenuOption = styled.div`
  //width: 100%;
  /* height: 2.3rem; */
  padding: 0.697rem 0 0.514rem 1.32rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;

  :hover {
    background: #eff1f5;
    &.filter-client {
      border-bottom-left-radius: 0.5rem;
      border-bottom-right-radius: 0.5rem;
    }
  }

  svg {
    margin-right: 1rem;
  }
`;

export const MenuText = styled.span`
  font-weight: 400;
  font-size: 0.81rem;
  line-height: 1.1rem;
  color: #212326;
  margin-left: 1rem;
`;
export const MenuUnmarked = styled.div`
  width: 1rem;
  height: 1rem;
  border-radius: 100%;
  background-color: #eff1f5;
`;
export const MenuCheck = styled.div`
  width: 1rem;
  height: 1rem;
  margin-right: 1rem;

  path {
    stroke: #40e5a0;
  }
`;

export const FilterClient = styled.div`
  position: absolute;
  width: 13.5rem;
  height: 9.2rem;
  border-radius: 8.46812px;
  background: #ffffff;
  left: 14rem;
  bottom: -19.3rem;
  display: flex;
  flex-direction: column;
  z-index: 1;
`;

export const FilterFlow = styled.div`
  position: absolute;
  width: 13.5rem;
  height: 9.2rem;
  border-radius: 8.46812px;
  background: #ffffff;
  left: 14rem;
  bottom: -21.6rem;
  display: flex;
  flex-direction: column;
  z-index: 1;
`;

export const FilterModalTitle = styled.span`
  font-weight: 400;
  font-size: 0.74rem;
  line-height: 0.95rem;
  color: #212326;

  margin-left: 1rem;
  margin-top: 1rem;
`;
export const FilterModalInput = styled.div`
  margin-top: 1rem;
  height: 2.15rem;
  width: 11.5rem;
  margin-left: 1rem;
`;

export const FilterModalButtons = styled.div`
  display: flex;
  justify-content: space-between;
  height: 1.9rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
  margin-left: 1rem;
  width: 11.5rem;
`;

export const FilterRenderControler = styled.div`
  position: relative;
`;

export const FilterActives1 = styled.div`
  position: absolute;
  left: 0rem;
  top: -2.5rem;
  margin-left: 1rem;
  display: flex;
  align-items: center;
  height: 1.7rem;
  background: #b9ebd6;
  border-radius: 4.2339px;
`;
export const FilterActives2 = styled.div`
  position: absolute;
  left: 0rem;

  margin-left: 1rem;
  display: flex;
  padding: 0.2rem;
  align-items: center;
  height: 1.7rem;
  background: #b9ebd6;
  border-radius: 4.2339px;
`;
export const FilterActives3 = styled.div`
  position: absolute;
  left: 0rem;
  top: ${({ Filter1Open, Filter2Open }) =>
    Filter1Open === '' && Filter2Open === ''
      ? '-2.5rem'
      : Filter1Open === '' || Filter2Open === ''
      ? '-0.5rem'
      : '1.5rem'};
  margin-left: 1rem;
  display: flex;
  align-items: center;
  height: 1.7rem;
  background: #b9ebd6;
  border-radius: 4.2339px;
`;

export const FilterActivesText = styled.span`
  font-weight: 600;
  font-size: 0.8rem;
  line-height: 1rem;
  color: #118052;
  margin-left: 0.7rem;
`;

export const FilterActivesData = styled.span`
  font-weight: 400;
  font-size: 0.8rem;
  line-height: 1rem;
  color: #118052;
  margin-left: 0.1rem;
  white-space: nowrap;
`;

export const FilterActivesClose = styled.div`
  margin-left: 0.5rem;
  margin-right: 0.7rem;
  width: 0.35rem;
  height: 0.35rem;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  path {
    stroke: #5bb18e;
  }
`;
